function isOmpPlatform() {
  return (
    ['kar-services', 'marketplace-shell', 'openlane'].some(elem => {
      return window.location.href?.includes(elem);
    }) || !!JSON.parse(localStorage?.getItem('nwContext') as string)
  );
}

export default isOmpPlatform;
